'use strict';
angular.module('previewRouterModule', ['versionModule', 'initPreviewBtnsModule', 'materialResourcePreviewModule']).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('preview', {
            url: '/preview?mrtype&relationid&resourcetype',
            views: {
                '': {
                    templateUrl: './resourceCenter/materialResource/preview/videoAndAudioPreview/preview.html',
                    controller: 'materialResourcePreviewCtrl',
                },
            },
        });
    },
]);
